module.exports = __webpack_public_path__ + "static/media/hiw1.288516b1.svg";